<template>
  <p class="text-center">{{ $t('weight_measurement.fill_with_api_response') }}</p>
</template>
